import { render, staticRenderFns } from "./CompleteUserPage.vue?vue&type=template&id=161c403e&scoped=true&"
import script from "./CompleteUserPage.vue?vue&type=script&lang=ts&"
export * from "./CompleteUserPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteUserPage.vue?vue&type=style&index=0&id=161c403e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c403e",
  null
  
)

export default component.exports